/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/image/image-cache.directive';
import * as import2 from '../../ui-elements/image/cached-image.service';
import * as import3 from '../../buttons/link/link.component.ngfactory';
import * as import4 from '../../buttons/link/link.component';
import * as import5 from '@angular/common';
import * as import6 from '../menu-item-panel/menu-item-panel.component.ngfactory';
import * as import7 from '../menu-item-panel/menu-item-panel.component';
import * as import8 from '../menu.model';
import * as import9 from '../../promo/promo.model';
import * as import10 from '../../order/order.model';
import * as import11 from '../../html-utils/css-var.directive';
import * as import12 from '../../orchestration/responsive.directive';
import * as import13 from '../../orchestration/responsive.service';
import * as import14 from '../../orchestration/navigation.service';
import * as import15 from 'ng2-translate/src/translate.pipe';
import * as import16 from 'ng2-translate/src/translate.service';
import * as import17 from '../../buttons/button/button.component.ngfactory';
import * as import18 from '../../buttons/button/button.component';
import * as import19 from '../../orchestration/session.model';
import * as import20 from '../../html-utils/html.pipe';
import * as import21 from '@angular/platform-browser';
import * as import22 from './menu-item-selection-panel.component';
const styles_MenuItemSelectionPanelComponent:any[] = ([] as any[]);
export const RenderType_MenuItemSelectionPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_MenuItemSelectionPanelComponent,
  data: {}
}
);
function View_MenuItemSelectionPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-contents-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.menuModel.selectedCategory.description));
    ck(v,0,0,currVal_0);
  });
}
function View_MenuItemSelectionPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'menu-contents-category-header-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'menu-contents-category-header-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import1.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import2.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.menuModel.getCategoryImage(co.menuModel.selectedCategory);
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[[
        'class',
        'menu-contents-category-header-details-action'
      ]
      ],(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.menuModel.deactivatePromotedCategory()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_LinkComponent_0,import3.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import4.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.common.close';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-contents-category-header-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),0),co.menuModel.selectedCategory.description));
    ck(v,0,0,currVal_0);
  });
}
function View_MenuItemSelectionPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'menu-contents-category-header'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.menuModel.selectAnchor(0,false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'menu-contents-category-header-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'menu-contents-category-header-details-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-image']),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_7)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showMainCategoryImage;
    ck(v,3,0,currVal_0);
    const currVal_1:any = 'menu-contents-category-header-details-name';
    const currVal_2:any = ck(v,9,0,co.showMainCategoryImage);
    ck(v,8,0,currVal_1,currVal_2);
    const currVal_4:any = ((co.showClosePromoAction && co.menuModel.selectedCategory) && !co.menuModel.selectedCategory.id);
    ck(v,13,0,currVal_4);
    const currVal_5:any = co.menuModel.selectedCategory.description;
    ck(v,17,0,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.menuModel.getCategoryDisplayName(co.menuModel.selectedCategory);
    ck(v,10,0,currVal_3);
  });
}
function View_MenuItemSelectionPanelComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-panel',[[
        'class',
        'menu-contents-category-items-item'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        2,
        'tile',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).selectItem($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_MenuItemPanelComponent_0,import6.RenderType_MenuItemPanelComponent)),
    import0.ɵdid(704512,(null as any),0,import7.MenuItemPanelComponent,[
      import8.MenuModel,
      import9.PromoModel,
      import0.ChangeDetectorRef,
      import10.OrderModel
    ]
    ,{
      category: [
        0,
        'category'
      ]
      ,
      menuItem: [
        1,
        'menuItem'
      ]
      ,
      tile: [
        2,
        'tile'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.menuModel.selectedCategory;
    const currVal_3:any = v.context.$implicit;
    const currVal_4:any = ((co.itemColumns(import0.ɵnov((<any>v.parent),5)) > 1) && co.menuModel.showItemImages);
    ck(v,1,0,currVal_2,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'item-',v.context.index,'');
    const currVal_1:any = import0.ɵnov(v,1).tile;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_MenuItemSelectionPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'anchorTarget',
        1
      ]

    ]
      ,(null as any),14,'div',[[
        'class',
        'menu-contents-category'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,[[
        'items',
        1
      ]
      ],(null as any),8,'div',[[
        'class',
        'menu-contents-category-items'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'tile',
      'with-header'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import11.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--item-columns']),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_8)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showMainCategoryHeader;
    ck(v,3,0,currVal_0);
    const currVal_1:any = 'menu-contents-category-items';
    const currVal_2:any = ck(v,7,0,((co.itemColumns(import0.ɵnov(v,5)) > 1) && co.menuModel.showItemImages),co.showMainCategoryHeader);
    ck(v,6,0,currVal_1,currVal_2);
    const currVal_3:any = ck(v,9,0,co.itemColumns(import0.ɵnov(v,5)));
    ck(v,8,0,currVal_3);
    const currVal_4:any = co.menuModel.getCategoryItems(co.menuModel.selectedCategory);
    ck(v,12,0,currVal_4);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'menu-contents-category-header-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'menu-contents-category-header-image-object'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import1.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import2.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.menuModel.getCategoryImage((<any>v.parent).context.$implicit);
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'menu-contents-category-header-description'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,1,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),(<any>v.parent).context.$implicit.description));
    ck(v,0,0,currVal_0);
  });
}
function View_MenuItemSelectionPanelComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-panel',[[
        'class',
        'menu-contents-category-items-item'
      ]
    ],[
      [
        8,
        'id',
        0
      ]
      ,
      [
        2,
        'tile',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).selectItem($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_MenuItemPanelComponent_0,import6.RenderType_MenuItemPanelComponent)),
    import0.ɵdid(704512,(null as any),0,import7.MenuItemPanelComponent,[
      import8.MenuModel,
      import9.PromoModel,
      import0.ChangeDetectorRef,
      import10.OrderModel
    ]
    ,{
      category: [
        0,
        'category'
      ]
      ,
      menuItem: [
        1,
        'menuItem'
      ]
      ,
      tile: [
        2,
        'tile'
      ]
      ,
      showDetails: [
        3,
        'showDetails'
      ]

    }
    ,(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = (<any>v.parent).context.$implicit;
    const currVal_3:any = v.context.$implicit;
    const currVal_4:any = ((co.itemColumns(import0.ɵnov((<any>v.parent),19)) > 1) && co.menuModel.showItemImages);
    const currVal_5:any = ((co.menuModel.selectedCategorySubcategories.length == 1) || co.anchorTargetHasBeenVisible[(<any>v.parent).context.index]);
    ck(v,1,0,currVal_2,currVal_3,currVal_4,currVal_5);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(2,'subcategory-item-',(<any>v.parent).context.index,'-',v.context.index,'');
    const currVal_1:any = import0.ɵnov(v,1).tile;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
function View_MenuItemSelectionPanelComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'anchorTarget',
        1
      ]

    ]
      ,(null as any),28,'div',[[
        'class',
        'menu-contents-category subcategory'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'menu-contents-category-header'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.menuModel.selectAnchor((v.context.index + (co.menuModel.selectedCategoryHasMainCategoryItems? 1: 0)),false,$event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_10)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'menu-contents-category-header-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'menu-contents-category-header-details-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-image']),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_11)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,[[
        'items',
        1
      ]
      ],(null as any),8,'div',[[
        'class',
        'menu-contents-category-items with-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['tile']),
      import0.ɵdid(671744,(null as any),0,import11.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--item-columns']),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_12)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = (co.menuModel.showSubcategoryImages && co.menuModel.getCategoryImage(v.context.$implicit));
    ck(v,5,0,currVal_1);
    const currVal_2:any = 'menu-contents-category-header-details-name';
    const currVal_3:any = ck(v,11,0,(co.menuModel.showSubcategoryImages && co.menuModel.getCategoryImage(v.context.$implicit)));
    ck(v,10,0,currVal_2,currVal_3);
    const currVal_5:any = v.context.$implicit.description;
    ck(v,16,0,currVal_5);
    const currVal_6:any = 'menu-contents-category-items with-header';
    const currVal_7:any = ck(v,21,0,((co.itemColumns(import0.ɵnov(v,19)) > 1) && co.menuModel.showItemImages));
    ck(v,20,0,currVal_6,currVal_7);
    const currVal_8:any = ck(v,23,0,co.itemColumns(import0.ɵnov(v,19)));
    ck(v,22,0,currVal_8);
    const currVal_9:any = co.menuModel.getCategoryItems(v.context.$implicit);
    ck(v,26,0,currVal_9);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'subcategory-',v.context.index,'');
    ck(v,0,0,currVal_0);
    const currVal_4:any = co.menuModel.getCategoryDisplayName(v.context.$implicit);
    ck(v,12,0,currVal_4);
  });
}
function View_MenuItemSelectionPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[
      [
        'class',
        'menu-contents'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'with-description-only',
      'with-images'
    ]
    ),
      import0.ɵdid(671744,(null as any),0,import11.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod(['--anchor-panel-height']),
    import0.ɵdid(737280,(null as any),0,import12.ResponsiveDirective,[
      import0.ElementRef,
      import13.ResponsiveService,
      import14.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_9)),
    import0.ɵdid(802816,(null as any),0,import5.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'menu-contents';
    const currVal_1:any = ck(v,2,0,(!co.showMainCategoryHeader && co.menuModel.selectedCategory.description),co.menuModel.showItemImages);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,4,0,(co.anchorPanelHeight + 'px'));
    ck(v,3,0,currVal_2);
    ck(v,5,0);
    const currVal_3:boolean = (!co.showMainCategoryHeader && co.menuModel.selectedCategory.description);
    ck(v,8,0,currVal_3);
    const currVal_4:any = co.showMainCategory;
    ck(v,11,0,currVal_4);
    const currVal_5:any = co.menuModel.selectedCategorySubcategories;
    ck(v,15,0,currVal_5);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'menu-nav'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'menu-nav-message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import15.TranslatePipe,[
      import16.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',[[
        'class',
        'menu-nav-action'
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,7).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.onBack.emit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import17.View_ButtonComponent_0,import17.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import18.ButtonComponent,[
      import0.ElementRef,
      import19.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_28:any = 'woa.button.item-selection.back';
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,7,0,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform('woa.message.item-selection.back-query'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,7).overrideFlatBackgroundColor;
    const currVal_2:any = import0.ɵnov(v,7).overrideFlatForegroundColor;
    const currVal_3:any = import0.ɵnov(v,7).overrideOutlineBackgroundColor;
    const currVal_4:any = import0.ɵnov(v,7).overrideOutlineForegroundColor;
    const currVal_5:any = import0.ɵnov(v,7).overrideOutlineBorderColor;
    const currVal_6:any = import0.ɵnov(v,7).overrideRaisedBackgroundColor;
    const currVal_7:any = import0.ɵnov(v,7).overrideRaisedForegroundColor;
    const currVal_8:any = import0.ɵnov(v,7).disabled;
    const currVal_9:any = import0.ɵnov(v,7).invisible;
    const currVal_10:any = import0.ɵnov(v,7).hovered;
    const currVal_11:any = import0.ɵnov(v,7).native;
    const currVal_12:any = import0.ɵnov(v,7).button;
    const currVal_13:any = import0.ɵnov(v,7).firstTier;
    const currVal_14:any = import0.ɵnov(v,7).secondTier;
    const currVal_15:any = import0.ɵnov(v,7).highProminence;
    const currVal_16:any = import0.ɵnov(v,7).lowProminence;
    const currVal_17:any = import0.ɵnov(v,7).affirmativeConnotation;
    const currVal_18:any = import0.ɵnov(v,7).dissuasiveConnotation;
    const currVal_19:any = import0.ɵnov(v,7).negativeConnotation;
    const currVal_20:any = import0.ɵnov(v,7).squareShape;
    const currVal_21:any = import0.ɵnov(v,7).roundedShape;
    const currVal_22:any = import0.ɵnov(v,7).ovalShape;
    const currVal_23:any = import0.ɵnov(v,7).flatStyle;
    const currVal_24:any = import0.ɵnov(v,7).outlineStyle;
    const currVal_25:any = import0.ɵnov(v,7).raisedStyle;
    const currVal_26:any = import0.ɵnov(v,7).verticalLayout;
    const currVal_27:any = import0.ɵnov(v,7).horizontalLayout;
    ck(v,6,1,[
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27
    ]
    );
  });
}
export function View_MenuItemSelectionPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    import0.ɵpid(0,import20.HtmlPipe,[import21.DomSanitizer]),
    import0.ɵqud(671088640,1,{anchorTargets: 1}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuItemSelectionPanelComponent_13)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import22.MenuItemSelectionPanelComponent = v.component;
    const currVal_0:any = (co.menuModel.selectedCategory && co.anchorPanel);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.showBackButton;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_MenuItemSelectionPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-menu-item-selection-panel',([] as any[]),(null as any),(null as any),(null as any),View_MenuItemSelectionPanelComponent_0,RenderType_MenuItemSelectionPanelComponent)),
    import0.ɵdid(4440064,(null as any),0,import22.MenuItemSelectionPanelComponent,[
      import8.MenuModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const MenuItemSelectionPanelComponentNgFactory:import0.ComponentFactory<import22.MenuItemSelectionPanelComponent> = import0.ɵccf('woa-menu-item-selection-panel',import22.MenuItemSelectionPanelComponent,View_MenuItemSelectionPanelComponent_Host_0,{
  showBackButton: 'showBackButton',
  showClosePromoAction: 'showClosePromoAction',
  alwaysShowCategoryHeader: 'alwaysShowCategoryHeader',
  pageScroller: 'pageScroller',
  anchorPanel: 'anchorPanel'
}
,{onBack: 'onBack'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/menu/menu-item-selection-panel/menu-item-selection-panel.component.ngfactory.ts